import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  HEADING_TYPE,
  TEXT_SIZES,
  DIVIDER_SIZE,
  BUTTON_TYPE,
} from '@helpers/constants'
import Heading from '@components/Heading'
import Divider from '@components/Divider'
import SectionList from '@components/SectionList'
import { getSubjectTextClass } from '@helpers/subject'
import Text from '@components/Text'
import Button from '@components/Button'

const FilterList = (props) => {
  const {availableSubjectAreas, selectedSubjectAreaId, setSelectedSubjectAreaId} = props

  return (
    <div className={'mt-3 inline-block'}>
      {Object.entries(availableSubjectAreas).map(
        ([availableSubjectAreaKey, availableSubjectArea], index) => {
          const { name, amount } = availableSubjectArea
          const isActive =
            selectedSubjectAreaId === availableSubjectAreaKey
          return (
            <Button
              key={availableSubjectAreaKey}
              type={BUTTON_TYPE.PRIMARY_OUTLINE}
              active={isActive}
              marginRight
              marginBottom
              handleClick={() => {
                if (isActive) {
                  setSelectedSubjectAreaId(null)
                } else {
                  setSelectedSubjectAreaId(availableSubjectAreaKey)
                }
              }}
            >
              {name} ({amount})
            </Button>
          )
        }
      )}
    </div>
  )
}

const SubjectSectionsGroup = (props) => {
  const {
    group: { subject, items },
    inLibraryView = false,
  } = props

  const [listLimit, setListLimit] = useState(6)
  const [selectedSubjectAreaId, setSelectedSubjectAreaId] = useState(null)

  const availableSubjectAreas = items.reduce((acc, item) => {
    if (item.subjectAreaTexts && item.subjectAreaTexts.length > 0) {
      let idsAlreadyAdded = []
      item.subjectAreaTexts.forEach((subjectAreaText) => {
        if (subjectAreaText.subjectArea) {
          if (acc[subjectAreaText.subjectArea.id]) {
            if (!idsAlreadyAdded.includes(subjectAreaText.subjectArea.id)) {
              acc[subjectAreaText.subjectArea.id].amount += 1
              idsAlreadyAdded.push(subjectAreaText.subjectArea.id)
            }
          } else {
            acc[subjectAreaText.subjectArea.id] = {
              name: subjectAreaText.subjectArea.name,
              amount: 1,
            }
            idsAlreadyAdded.push(subjectAreaText.subjectArea.id)
          }
        }
      })
      return acc
    } else {
      return acc
    }
  }, {})

  const filterBySubjectArea = (items) => {
    const filtered = items.filter((item) => {
      let hasMatch = false

      if (item.subjectAreaTexts.length > 0) {
        item.subjectAreaTexts.forEach((element) => {
          if (element.subjectArea.id === selectedSubjectAreaId && !hasMatch) {
            hasMatch = true
          }
        })
      }

      return hasMatch
    })

    return filtered
  }

  const filteredItems =
    selectedSubjectAreaId !== null ? filterBySubjectArea(items) : items

  const limitedItems = filteredItems.slice(0, listLimit)

  return (
    <div className={'w-full'}>
      <Heading
        extraClasses={getSubjectTextClass(subject?.slug, 'dark')}
        size={TEXT_SIZES.XXLARGE}
        headingLevel={HEADING_TYPE.H1}
      >
        {subject?.name}
      </Heading>
      <Divider size={DIVIDER_SIZE.SMALL} />

      {Object.entries(availableSubjectAreas).length > 0 && (
        <>
          <Text size={TEXT_SIZES.XXSMALL} bold uppercase>
            Centralt innehåll:
          </Text>

          <FilterList
            {...{
              availableSubjectAreas,
              selectedSubjectAreaId,
              setSelectedSubjectAreaId,
            }}
            tooltipProps={{
              offset: [10, 10],
              placement: 'bottom-start',
            }}
            tooltip={'Visa innehållet utifrån läroplanens rubriker.'}
          />
          <Divider size={DIVIDER_SIZE.SMALL} />
        </>
      )}

      <SectionList items={limitedItems} inLibraryView={inLibraryView}/>

      {limitedItems.length < filteredItems.length && (
        <>
          <Divider size={DIVIDER_SIZE.SMALL} />
          <div className={'flex justify-end'}>
            <Button
              handleClick={() => {
                setListLimit(9999)
              }}
              type={BUTTON_TYPE.SECONDARY}
              icon={'ChevronDown'}
              iconRight
            >
              Visa alla
            </Button>
          </div>
        </>
      )}

      <Divider size={DIVIDER_SIZE.MEDIUM} />
    </div>
  )
}

SubjectSectionsGroup.propTypes = {
  group: PropTypes.object,
  inLibraryView: PropTypes.bool,
}

export default SubjectSectionsGroup
